// extracted by mini-css-extract-plugin
export default {"root":"ReadModal_root__RoGZf","footer":"ReadModal_footer__6e8OV","button":"ReadModal_button__zKJEn"};